import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatDate(date: string | Date | null | undefined) {
  if (!date) return 'Non disponible';
  
  const dateObj = new Date(date);
  
  // Vérifier si la date est valide
  if (isNaN(dateObj.getTime())) {
    // Essayer de parser une date au format ISO
    if (typeof date === 'string') {
      // Format possible: YYYY-MM-DD
      const matches = date.match(/^(\d{4})-(\d{2})-(\d{2})/);
      if (matches) {
        return new Date(parseInt(matches[1]), parseInt(matches[2])-1, parseInt(matches[3]))
          .toLocaleDateString('fr-FR', {
            day: 'numeric',
            month: 'short',
            year: 'numeric',
          });
      }
    }
    return 'Date invalide';
  }
  
  return dateObj.toLocaleDateString('fr-FR', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
}

export function getSeverityColor(severity: string) {
  switch (severity.toLowerCase()) {
    case 'critical':
      return 'rgb(220, 38, 38)' // red-600
    case 'high':
      return 'rgb(239, 68, 68)' // red-500
    case 'medium':
      return 'rgb(234, 179, 8)' // yellow-500
    case 'low':
      return 'rgb(34, 197, 94)' // green-500
    case 'info':
      return 'rgb(59, 130, 246)' // blue-500
    default:
      return 'rgb(156, 163, 175)' // gray-400
  }
}

export function getStatusColor(status: string) {
  switch (status.toLowerCase()) {
    case 'open':
      return 'rgb(239, 68, 68)' // red-500
    case 'in progress':
      return 'rgb(234, 179, 8)' // yellow-500
    case 'resolved':
      return 'rgb(34, 197, 94)' // green-500
    case 'closed':
      return 'rgb(59, 130, 246)' // blue-500
    default:
      return 'rgb(156, 163, 175)' // gray-400
  }
}

export function truncateText(text: string, maxLength: number) {
  if (text.length <= maxLength) return text
  return text.slice(0, maxLength) + '...'
}
